import { ChangeDetectorRef, Component } from '@angular/core';
import { Inspection } from '../../../shared/models/inspection.model';
import { BasePlugin } from '../../base-plugin.component';
import { PluginComponent } from '../../plugin.component';

@Component({
    templateUrl: './received.component.html',
    standalone: false
})
export class InstallationReceivedPluginComponent {
  public receivedValues: any[];
  public config: any;
  public editRoute = ['installation', 'received', 'edit'];

  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    this.receivedValues = this.config.ReceivedValues;
  }
}
PluginComponent.plugins['installationreceived'] = InstallationReceivedPluginComponent;
